import _ from 'lodash';
import ItemComponent from "../../../../core/infraestructure/ItemComponent";
import CourseDetailViewModel from "../../../../core/features/course/viewmodels/CourseDetailViewModel";

export default {
  extends: ItemComponent,
  data() {
    return {
      viewModel: null,
      specialtySelected: null,
      isContentLoading: false,
      courseSections: [],
    };
  },
  props: {
    courseDetails: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.viewModel = new CourseDetailViewModel(this);
    this.filterSections(this.courseDetails?.specialty);
  },
  mounted() {
    this.filterSections(this.courseDetails?.specialty);
  },
  methods: {
    orderSections(collection) {
      return _.sortBy(collection, "sort");
    },
    filterSections(specialtyId) {
      if (!this.courseDetails || !this.courseDetails.courseSections) {
        this.courseSections = [];
        return;
      }
      this.courseSections = this.courseDetails.courseSections.filter((item) => {
        if (specialtyId) {
          const specialties = _.filter(item.specialties, { id: specialtyId });
          return (!item.isSpecialty && _.isEmpty(specialties)) || (item.isSpecialty && !_.isEmpty(specialties));
        }
        return item;
      });
    },
  },
  watch: {
    'courseDetails.specialty': {
      handler(newValue) {
        this.filterSections(newValue);
      },
      immediate: true,
    },
    'courseDetails.courseSections': {
      handler() {
        this.filterSections(this.courseDetails?.specialty);
      },
      immediate: true,
    },
  },
};
